import _ from 'lodash';

const putOpts = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' }
};

const postOpts = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
};

const fetchRemote = (fullEndpoint, opts) => {
    return new Promise((resolve, reject) => {
        fetch(fullEndpoint, opts).then((response) => {
            if(response.ok){
                resolve(response);
            } else {
                reject(response.statusText);
            }
        });
    });
};

const fetchRemoteJson = (endpoint, options) => {
    return new Promise((resolve, reject) => {
        fetchRemote(endpoint, options).then(
            response => {
                resolve(response.json());
            }, reject
        ).catch(reject);
    });
};

const putRemote = (endpoint, model, opts) => {
    opts = opts || {};
    opts.body = JSON.stringify(model);

    const options = _.merge({}, putOpts , opts);
    return fetchRemoteJson(endpoint, options);
};

const putRemoteResult = (endpoint, model, opts) => {
    opts = opts || {};
    opts.body = JSON.stringify(model);

    const options = _.merge({}, putOpts , opts);
    return fetchRemoteResult(endpoint, options);
};

const postRemote = (endpoint, model, opts) => {
    opts = opts || {};
    opts.body = JSON.stringify(model);
    const options = _.merge({}, postOpts , opts);
    return fetchRemoteJson(endpoint, options);
};

const fetchRemoteResult = (fullEndpoint, opts) => {
    return new Promise((resolve, reject) => {
        fetchRemote(fullEndpoint, opts).then(response => {
            response.json().then(data => {
                if(!data.success){
                    reject(data.errors);
                    return;
                }
                resolve(data.value);
            }, reject);
        }).catch(reject);
    });
};

export {
    fetchRemote,
    fetchRemoteResult,
    fetchRemoteJson,
    postRemote,
    putRemote,
    putRemoteResult,
    putOpts,
    postOpts
};
